import React from 'react';

type FormErrorProps = {
  message?: string;
  icon?: React.ReactNode | null;
  id?: string;
};

export default function FormError({ message, icon, id }: FormErrorProps) {
  return (
    <div className="flex flex-row gap-1 items-start self-stretch mt-2">
      <div className="shrink-0">{icon}</div>
      <p id={id} role="alert" className="text-xs text-[#e23f04] ">
        {message}
      </p>
    </div>
  );
}
